/**
 * Simple Announcements Dismissal
 * 
 * Handles dismissing all announcements with simple boolean localStorage
 */

class AnnouncementsDismissal {
  constructor() {
    this.init();
  }

  init() {
    // Check for dismissed status on page load
    document.addEventListener('DOMContentLoaded', () => {
      this.checkDismissedStatus();
      this.setupDismissalHandlers();
    });
    
    // Listen for htmx events to reinitialize after Sprig updates
    document.addEventListener('htmx:afterSettle', () => this.setupDismissalHandlers());
  }

  checkDismissedStatus() {
    const dismissedData = localStorage.getItem('announcementsDismissed');
    if (dismissedData) {
      const parsed = JSON.parse(dismissedData);
      const now = new Date().getTime();
      
      // Check if dismissal is still valid (within 1 day)
      if (parsed.dismissed && (now - parsed.timestamp < 24 * 60 * 60 * 1000)) {
        // Hide announcements container and remove body padding
        const announcementsContainer = document.querySelector('#announcements-banner');
        if (announcementsContainer) {
          announcementsContainer.classList.add('hidden');
        }
        document.body.style.paddingTop = '0';
        
        // Stop auto-rotate
        this.stopAutoRotate();
      } else {
        // Expired, remove from localStorage
        localStorage.removeItem('announcementsDismissed');
      }
    }
  }

  setupDismissalHandlers() {
    const dismissButtons = document.querySelectorAll('[data-dismiss-announcement]');
    
    dismissButtons.forEach(button => {
      // Remove existing listener to prevent duplicates
      button.removeEventListener('click', this.handleDismiss);
      button.addEventListener('click', this.handleDismiss.bind(this));
    });
  }

  handleDismiss(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Save dismissal to localStorage with timestamp
    const dismissalData = {
      dismissed: true,
      timestamp: new Date().getTime()
    };
    localStorage.setItem('announcementsDismissed', JSON.stringify(dismissalData));
    
    // Stop auto-rotate
    this.stopAutoRotate();
    
    // Hide announcements container
    const announcementsContainer = document.querySelector('#announcements-banner');
    if (announcementsContainer) {
      announcementsContainer.classList.add('opacity-0');
      
      setTimeout(() => {
        announcementsContainer.classList.add('hidden');
        // Remove body padding
        document.body.style.paddingTop = '0';
      }, 300);
    }
  }

  stopAutoRotate() {
    // Clear any existing auto-rotate timers
    if (window.autoRotateTimer) {
      clearTimeout(window.autoRotateTimer);
      window.autoRotateTimer = null;
    }
  }

  // Check if announcements are currently dismissed
  static isDismissed() {
    const dismissedData = localStorage.getItem('announcementsDismissed');
    if (dismissedData) {
      const parsed = JSON.parse(dismissedData);
      const now = new Date().getTime();
      // Return true if dismissed and still valid (within 1 day)
      return parsed.dismissed && (now - parsed.timestamp < 24 * 60 * 60 * 1000);
    }
    return false;
  }
}

// Initialize
new AnnouncementsDismissal();

// Make dismissed IDs available globally for Sprig to access
window.AnnouncementsDismissal = AnnouncementsDismissal;

export default AnnouncementsDismissal;